import React from 'react';

const Footer = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section footer-brand">
            <img src="/logo.png" alt="CAEI Logo" className="footer-logo" />
            {/*<h3>CAEI</h3>*/}
            <p>Community Awareness and Empowerment Initiative</p>
            <p className="footer-tagline">Turning pain into strength</p>
          </div>
          <div className="footer-section">
            <h4>Quick Links</h4>
            <ul>
              <li><a href="#home" onClick={(e) => { e.preventDefault(); scrollToSection('home'); }}>Home</a></li>
              <li><a href="#about" onClick={(e) => { e.preventDefault(); scrollToSection('about'); }}>About</a></li>
              <li><a href="#services" onClick={(e) => { e.preventDefault(); scrollToSection('services'); }}>Services</a></li>
              <li><a href="#contact" onClick={(e) => { e.preventDefault(); scrollToSection('contact'); }}>Contact</a></li>
            </ul>
          </div>
          <div className="footer-section">
            <h4>Our Values</h4>
            <ul>
              <li>Compassion</li>
              <li>Dignity</li>
              <li>Justice</li>
              <li>Hope</li>
            </ul>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} Community Awareness and Empowerment Initiative (CAEI). All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
